export default __webpack_public_path__ + "static/media/skill-storytelling.1fb4523d.svg";